import { ColDef, IRowNode } from '@ag-grid-community/core';
import { MONITOR_ADD_SORT_COLUMNS } from './MonitorTable.constants';
import { MonitorDto } from '../../../../../services/dtos/riskProducts/monitor.dto';
import { DEFAULT_MONITOR_COLUMNS } from '../Monitor.constants';
import { EsField } from '../../../../../services/dtos/riskProducts/rpColumn.dto';

export const columnNumSort = (fieldCompareName: string, nodeA: IRowNode<any>, nodeB: IRowNode<any>): number => {
  let res = 0;

  if (fieldCompareName in nodeA.data && fieldCompareName in nodeB.data) {
    if (nodeA.data[fieldCompareName] && nodeB.data[fieldCompareName]) {
      res = nodeA.data[fieldCompareName] - nodeB.data[fieldCompareName];
    } else if (nodeA.data[fieldCompareName] === null) {
      res = -1;
    } else if (nodeB.data[fieldCompareName] === null) {
      res = 1;
    }
  }
  return res;
};

export const columnSortDefsGet = (columnDefs: ColDef<MonitorDto>[]): ColDef<MonitorDto>[] => {
  const columnSortDefs = [...columnDefs];
  columnSortDefs.forEach((columnSortDef: ColDef<MonitorDto>, ind: number) => {
    const fieldName: string = columnSortDef.field as string;
    if (fieldName in MONITOR_ADD_SORT_COLUMNS) {
      const fieldCompareName: string = MONITOR_ADD_SORT_COLUMNS[fieldName];
      columnSortDefs[ind].comparator = (valueA, valueB, nodeA: IRowNode<any>, nodeB: IRowNode<any>) => {
        return columnNumSort(fieldCompareName, nodeA, nodeB);
      };
    }
  });
  return columnSortDefs;
};

const columnsComparator = (a: ColDef<MonitorDto>, b: ColDef<MonitorDto>): number => {
  const indexA = DEFAULT_MONITOR_COLUMNS.indexOf(a.colId as EsField);
  const indexB = DEFAULT_MONITOR_COLUMNS.indexOf(b.colId as EsField);
  return indexA - indexB;
};

export const getInitialMonitorColumns = (allColumnDefinitions: ColDef<MonitorDto>[]): ColDef<MonitorDto>[] => {
  const columnDefs: ColDef<MonitorDto>[] = allColumnDefinitions
    .filter((column) => DEFAULT_MONITOR_COLUMNS.includes(column.colId as string))
    .sort(columnsComparator);

  return columnDefs;
};
